import { render, staticRenderFns } from "./MitReservationSetupRequests.vue?vue&type=template&id=64ce1b68&scoped=true"
import script from "./MitReservationSetupRequests.vue?vue&type=script&lang=js"
export * from "./MitReservationSetupRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce1b68",
  null
  
)

export default component.exports